/* IMS Actions */
import { SIGN_IN, SIGN_OUT, ADD_PROFILE } from '../constants';

export const signIn = (profile) => async (dispatch) => {
  dispatch({ type: SIGN_IN, payload: profile });
};

export const signOut = () => async (dispatch) => {
  dispatch({ type: SIGN_OUT });
};
export const addProfile = (profile) => ({
  type: ADD_PROFILE,
  payload: profile
});